import { STORE_LOCATION, JHAJJAR_BOUNDARY } from './constants';

function toRad(deg) {
  return deg * (Math.PI / 180);
}

export function getDistanceKm(lat1, lng1, lat2, lng2) {
  const R = 6371;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

export function isInsidePolygon(lat, lng, polygon) {
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i].lat, yi = polygon[i].lng;
    const xj = polygon[j].lat, yj = polygon[j].lng;
    if ((yi > lng) !== (yj > lng) && lat < (xj - xi) * (lng - yi) / (yj - yi) + xi) {
      inside = !inside;
    }
  }
  return inside;
}

export function isWithinServiceArea(lat, lng) {
  if (isInsidePolygon(lat, lng, JHAJJAR_BOUNDARY)) {
    return true;
  }
  const dist = getDistanceKm(lat, lng, STORE_LOCATION.lat, STORE_LOCATION.lng);
  return dist <= (SERVICE_RADIUS_KM || 3);
}

export function getCurrentLocation() {
  if (typeof window !== 'undefined' && window.location) {
    const path = (window.location.pathname || '').toLowerCase();
    if (path.includes('terms') || path.includes('privacy') || path.includes('policy') || path.includes('legal')) {
      return Promise.reject(new Error('Location access is restricted on policy and terms pages'));
    }
  }

  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation is not supported by your browser or device'));
      return;
    }

    // Try high accuracy first (10s timeout)
    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          lat: position.coords.latitude,
          lng: position.coords.longitude
        });
      },
      (error) => {
        // Fallback to coarse accuracy if high accuracy timed out or failed
        if (error.code === error.TIMEOUT || error.code === error.POSITION_UNAVAILABLE) {
          navigator.geolocation.getCurrentPosition(
            (fallbackPos) => {
              resolve({
                lat: fallbackPos.coords.latitude,
                lng: fallbackPos.coords.longitude
              });
            },
            (fallbackErr) => {
              reject(fallbackErr);
            },
            { enableHighAccuracy: false, timeout: 8000, maximumAge: 600000 }
          );
        } else {
          reject(error);
        }
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 300000 }
    );
  });
}
